// extracted by mini-css-extract-plugin
export default {"item":"PlayerItem_item__Fuhki","image":"PlayerItem_image__CVKGD","content":"PlayerItem_content__6gCzp","contenth":"PlayerItem_contenth__t772i","actions":"PlayerItem_actions__BnAm8"};